import {call, put} from 'redux-saga/effects';
import NotificationActions from '../redux/NotificationRedux';
import NotificationsActions from '../redux/NotificationsRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getNotification(api, action) {
  const response = yield call(api.getNotification, action.id);

  if (response.ok) {
    yield put(NotificationActions.notificationSuccess(response.data));
  } else {
    yield put(NotificationActions.notificationFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * addNotification(api, action) {
  const response = yield call(api.addNotification, {...action.data});

  if (response.ok) {
    yield put(NotificationActions.notificationSuccess(response.data));
    yield put(NotificationsActions.notificationsSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'notificationAdd', title: 'Запись успешно создана'}));
  } else {
    yield put(NotificationActions.notificationFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * updateNotification(api, action) {
  const response = yield call(api.editNotification, {...action.data});

  if (response.ok) {
    yield put(NotificationActions.notificationSuccess(response.data));
    yield put(NotificationsActions.notificationsSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'notificationUpdate', title: 'Запись успешно обновлена'}));
  } else {
    yield put(NotificationActions.notificationFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * deleteNotification(api, action) {
  const response = yield call(api.deleteNotification, action.id);

  if (response.ok) {
    yield put(NotificationActions.notificationSuccess(null));
    yield put(NotificationsActions.notificationsSuccess({removedId: action.id}));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'notificationDelete', title: 'Запись успешно удалена'}));
  } else {
    yield put(NotificationActions.notificationFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
